import React from 'react';
import Icon from '../../../components/AppIcon';

const HoursSchedule = () => {
  const currentDay = new Date()?.getDay();
  
  const schedule = [
    { day: "Monday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 1 },
    { day: "Tuesday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 2 },
    { day: "Wednesday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 3 },
    { day: "Thursday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 4 },
    { day: "Friday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 5 },
    { day: "Saturday", hours: "7:00 AM - 7:00 PM", isOpen: true, dayIndex: 6 },
    { day: "Sunday", hours: "8:00 AM - 5:00 PM", isOpen: true, dayIndex: 0 }
  ];

  const isCurrentlyOpen = () => {
    const now = new Date();
    const currentHour = now?.getHours();
    const currentMinute = now?.getMinutes();
    const currentTime = currentHour * 60 + currentMinute;

    if (currentDay === 0) {
      return currentTime >= 480 && currentTime < 1020;
    }
    return currentTime >= 420 && currentTime < 1140;
  };

  const openNow = isCurrentlyOpen();

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="Clock" size={20} color="var(--color-primary)" />
            </div>
            <h2 className="text-2xl font-serif font-semibold text-foreground">
              Opening Hours
            </h2>
          </div>
          <div className={`px-3 py-1 rounded-full text-sm font-medium ${
            openNow 
              ? 'bg-success/10 text-success' :'bg-error/10 text-error'
          }`}>
            {openNow ? 'Open Now' : 'Closed'}
          </div>
        </div>
        <p className="text-muted-foreground">
          Fresh baked goods daily, prepared with love and tradition
        </p>
      </div>
      <div className="p-6">
        <div className="space-y-3">
          {schedule?.map((item) => (
            <div
              key={item?.day}
              className={`flex items-center justify-between p-4 rounded-lg transition-all ${
                item?.dayIndex === currentDay
                  ? 'bg-primary/5 border-2 border-primary/20' :'bg-muted/30 border-2 border-transparent'
              }`}
            >
              <div className="flex items-center gap-3">
                {item?.dayIndex === currentDay && (
                  <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                )}
                <span className={`font-medium ${
                  item?.dayIndex === currentDay 
                    ? 'text-foreground' 
                    : 'text-muted-foreground'
                }`}>
                  {item?.day}
                </span>
              </div>
              <span className={`text-sm ${
                item?.dayIndex === currentDay 
                  ? 'text-foreground font-medium' 
                  : 'text-muted-foreground'
              }`}>
                {item?.hours}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Holiday Hours
              </p>
              <p className="text-sm text-muted-foreground">
                Hours may vary during holidays. Please call ahead or check our social media for updates during Christmas, New Year, and other special occasions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoursSchedule;